import React from 'react';
import CourseListModel from '../../../models/courses/CourseListModel';
import IAccordion from '../../../models/accordion/IAccordion';
import CourseList from '../../molecules/course-list/course-list';
import { BrandField } from '../../../models/course/ICourseContent';
import RichText from '../../atoms/rich-text/rich-text';
import AccordionGroup from '../../molecules/accordion-group/accordion-group';
import { ApplicationSettings } from '../../../models/settings';
import SidebarNavigation from '../../molecules/sidebar-navigation/sidebar-navigation';
import styles from './courses-page.module.scss';
import { studyLevel } from '../../../constants/study-level';

type Props = {
  courses: CourseListModel;
  brand: BrandField;
  introText: any;
  appSettings: ApplicationSettings;
  application: string;
  pagePath?: string;
  locales?: string[];
};

export default function CoursesPage({
  courses,
  brand,
  introText,
  appSettings,
  pagePath,
  locales,
  application,
}: Props) {
  const accordionProps: IAccordion[] = [];
  const programGroups = brand.brandOptions?.fields?.programGroups?.map(
    (x) => x.fields.programGroupName,
  );

  Object.keys(courses).forEach((level) => {
    const levelContent = Object.keys(courses[level])
      .sort(
        (a, b) =>
          programGroups?.findIndex((x) => x === a) - programGroups?.findIndex((x) => x === b),
      )
      .map((groupKey) => {
        const contentfulProgramGroup = brand.brandOptions?.fields?.programGroups?.find(
          (programGroup) => programGroup.fields.programGroupName === groupKey,
        );

        return (
          <CourseList
            application={application}
            key={groupKey}
            courses={courses[level][groupKey]}
            groupName={groupKey}
            title={contentfulProgramGroup?.fields?.name || groupKey}
            intro={contentfulProgramGroup?.fields?.description}
            programName={brand.countryCode === 'US' ? 'programs' : 'courses'}
          />
        );
      });

    accordionProps.push({
      id: level,
      heading: studyLevel[level],
      content: levelContent,
    });
  });

  const coursesPageElements = (
    <>
      <h1 className={'mb-4'}>
        Your {brand.countryCode === 'US' ? 'programs' : 'courses'} at {brand.brandName}
      </h1>
      {introText?.fields?.richText ? (
        <RichText richText={{ json: introText.fields.richText }} />
      ) : null}
      {accordionProps.length ? (
        <>
          <h2 className={'mt-5 mb-4 fs-4'}>
            {brand.countryCode === 'US' ? 'Programs' : 'Courses'}
          </h2>
          <AccordionGroup accordionProps={accordionProps} />
        </>
      ) : null}
    </>
  );

  return (
    <div className='container'>
      {brand?.brandOptions?.fields?.navigation ? (
        <div className='custom-page-template'>
          <div className='row'>
            <div className='col-lg-3 px-0 px-lg-3'>
              <SidebarNavigation
                sidebarNavigationProps={brand?.brandOptions?.fields?.navigation?.fields}
                sidebarBrandColor={appSettings.branding.primaryColor}
                b2cFlag={appSettings.b2cFlag}
                pagePath={pagePath}
                locales={locales}
              />
            </div>
            <div className={`${styles[`course-list-with-navs`]} col-lg-9 py-lg-4 py-0`}>
              {coursesPageElements}
            </div>
          </div>
        </div>
      ) : (
        <div className='col-lg-9'>{coursesPageElements}</div>
      )}
    </div>
  );
}
